import { render, staticRenderFns } from "./index.vue?vue&type=template&id=908e6074&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=908e6074&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=908e6074&lang=scss&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=908e6074&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908e6074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('908e6074')) {
      api.createRecord('908e6074', component.options)
    } else {
      api.reload('908e6074', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=908e6074&scoped=true", function () {
      api.rerender('908e6074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/login/index.vue"
export default component.exports